module.exports = __webpack_public_path__ + "static/media/pastEvent.55f8fd7a.png";